import { useState } from 'react';
import useApi from './useApi';
import { tap } from 'ramda';
import { authedClient } from '@/api/trpc';
import { env } from '../env';
import type { AuthUser } from '@/types/auth';
import type { AuthContextType } from '@/context/AuthProvider';

export default function useProvideAuth(): AuthContextType {
  const [user, setUser] = useState<any>({});
  const [currentUser, setCurrentUser] = useState<AuthUser | null>(null);
  const [isLoadingCurrent, setIsLoadingCurrent] = useState(false);
  const { userApi } = useApi();

  const logIn = async (email: string, password: string, sessionCloseMode?: 'closeOldest' | 'closeAll') => {
    const principalTypeMap: Record<string, string> = {
      'Companies': 'company',
      'users': 'user',
      'Customers': 'CustomerApp'
    };
    const principalType: any = principalTypeMap[env.REACT_APP_USER_API_PATH];

    return authedClient.auth.login.mutate({
      email,
      password,
      principalType,
      sessionCloseMode
    })
      .then(tap((data: any) => {
        const userData = data?.user;
        const accessToken = data?.id;
        setUser(() => ({
          ...data,
          user: userData,
          accessToken
        }));
      }));
  };

  const signUp = (data: any) => {
    return userApi
      .signup(data)
      .then(() =>
        logIn(data.email, data.password)
      );
  };

  const logOut = async () => {
    return authedClient.auth.logout.query()
      .then(() => {
        setUser({});
        setCurrentUser(null);
      });
  };

  const sendPasswordResetEmail = (email: string) => {
  };

  const confirmPasswordReset = (code: string, password: string) => {
  };

  return {
    user,
    setUser,
    logIn,
    signUp,
    logOut,
    sendPasswordResetEmail,
    confirmPasswordReset,
    currentUser,
    setCurrentUser,
    isLoadingCurrent,
  };
}
